import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { api } from "../../../../../../../utility/AxiosInceptor";
import { InputText } from "primereact/inputtext";

import { Toast } from "primereact/toast";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import AddAgentDetail from "./Dialogs/add_agent_detail";
import AddSimModelDialog from "./Dialogs/add_sim_model_dialog";

export default function UpdateDeviceSingleUpload({
  permissions,
  setUpdateInventory,
}) {
  let ref = useRef(null);
  //Getting User Data from localstorage
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  //Adding SIM Model And Agent Details Screen Dialog Visibility
  const [addsim_Model_dialog_visibility, setAddSimModelDialogVisbility] =
    useState(false);
  const [add_agent_detail_dialog_visibility, setAddAgentDialogVisbility] =
    useState(false);
  const [carrier, setCarrier] = useState(null);
  const [department, setDepartment] = useState(null);
  const [agent, setAgent] = useState(null);
  const [departmentselected, setDepartmentSelected] = useState(null);
  const [Model, setModel] = useState(null);
  const [defaultSelectedAgent, setDefaultSelectedAgent] = useState(null);
  const [esnExist, setEsnExist] = useState(null);
  const [simNumberError, setSimNumberError] = useState(false);
  const [imeiNumberError, setImeiNumberError] = useState(false);
  useEffect(() => {
    //Getting Department Selected and Whenever its value change calling this api to get agentName for DropDown and Setting it
    if (departmentselected !== null) {
      api
        .get(`/api/web/user/getByDepartments?department=${departmentselected}`)
        .then((res) => {
          let agentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].name;
            obj.value = res.data.data[i]._id;
            agentholder.push(obj);
          }

          setAgent(agentholder);
          if (defaultSelectedAgent !== null) {
            formik.setFieldValue("AgentName", defaultSelectedAgent);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentselected]);
  useEffect(() => {
    //Getting carriers  for DropDown and Setting it

    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = res.data.data[i]._id;
          carrierholder.push(obj);
        }

        setCarrier(carrierholder);
      })
      .catch(() => {});
    //Getting SIM Model Type for DropDown and Setting it

    api
      .get(`/api/simType/all`)
      .then((res) => {
        let Modelholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].simType;
          obj.value = res.data.data[i].simType;
          Modelholder.push(obj);
        }

        setModel(Modelholder);
      })
      .catch(() => {});
    //Getting Departments for DropDown and Setting it
    if (department === null) {
      api
        .get(`/api/deparments/getDepartments?company=${parseLoginRes.company}`)
        .then((res) => {
          let departmentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].department;
            obj.value = res.data.data[i]._id;
            departmentholder.push(obj);
          }
          setDepartment(departmentholder);
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const formik = useFormik({
    validationSchema: Yup.object({
      SimNumberToUpdate: Yup.string()
        .required("SIM Number Is Required")
        .min(18, "Sim Number must be at least  18 characters")
        .max(19, "Sim Number must be at most 19 characters"),
    }),
    initialValues: {
      carrier: "",
      agentType: "",
      AgentName: "",
      SimNumber: "",
      SimNumberToUpdate: "",
      box: "",
      Model: "",
      status: "",
      IMEI: "",
    },
    onSubmit: (e) => {
      handlesubmit();
    },
  });
  function handlePopulateDataByEsn(e) {
    if (e.target.value.length === 18 || e.target.value.length === 19) {
      //Getting SIM Details

      api
        .get(`/api/web/simInventory/getByESN?esn=${e.target.value}`)
        .then((res) => {
          setEsnExist(e.target.value);

          formik.setFieldValue("agentType", res.data.data.AgentType._id);
          formik.setFieldValue("carrier", res.data.data.carrier._id);
          formik.setFieldValue("status", res.data.data.status);
          formik.setFieldValue("Model", res.data.data.Model.toLowerCase());
          formik.setFieldValue("box", res.data.data.box);
          formik.setFieldValue("IMEI", res.data.data.IMEI);
          formik.setFieldValue("SimNumber", res.data.data.SimNumber);

          setDefaultSelectedAgent(res.data.data.AgentName._id);
          setDepartmentSelected(res.data.data.AgentType._id);

          toast.success("Inventory Detail Successfully Fetched");
        })
        .catch((err) => {
          //Setting this to null so Api Not call if ESN Not found in Inventory
          setEsnExist(null);
          formik.setFieldValue("carrier", "");
          formik.setFieldValue("status", "");
          formik.setFieldValue("Model", "");
          formik.setFieldValue("box", "");
          formik.setFieldValue("IMEI", "");
          formik.setFieldValue("SimNumber", "");
          setDefaultSelectedAgent(null);
          setDepartmentSelected(null);

          toast.error(err?.response?.data?.message);
          toast.error(err?.response?.data?.msg);
        });
    } else {
      setEsnExist(null);
      formik.setFieldValue("carrier", "");
      formik.setFieldValue("status", "");
      formik.setFieldValue("Model", "");
      formik.setFieldValue("box", "");
      formik.setFieldValue("SimNumber", "");
      formik.setFieldValue("IMEI", "");
      setDefaultSelectedAgent(null);
      setDepartmentSelected(null);
    }
    formik.setFieldValue("SimNumberToUpdate", e.target.value);
  }
  function handlesubmit() {
    let obj = formik.values;
    let currentvalue = obj.SimNumberToUpdate;
    Object.keys(obj).forEach((item) => {
      if (obj[item].length === 0) {
        delete obj[item];
      }
    });
    delete obj.SimNumberToUpdate;

    if (esnExist !== null) {
      if (obj.hasOwnProperty("SimNumber") && obj.hasOwnProperty("IMEI")) {
        if (
          formik.values.SimNumber.length === 18 ||
          formik.values.SimNumber.length === 19
        ) {
          if (formik.values.IMEI.length === 15) {
            api
              .put(`/api/web/simInventory/update?simNumber=${esnExist}`, obj)
              .then(() => {
                obj.SimNumberToUpdate = currentvalue;

                toast.success("Inventory Successfully Updated");
              })
              .catch(() => {
                obj.SimNumberToUpdate = currentvalue;
                toast.error("Inventory Updation Failed");
              });
          } else {
            obj.SimNumberToUpdate = currentvalue;
            setImeiNumberError(true);
          }
        } else {
          if (formik.values.IMEI.length === 15) {
          } else {
            setImeiNumberError(true);
          }
          obj.SimNumberToUpdate = currentvalue;
          setSimNumberError(true);
        }
      } else {
        if (obj.hasOwnProperty("SimNumber")) {
          if (
            formik.values.SimNumber.length === 18 ||
            formik.values.SimNumber.length === 19
          ) {
            api
              .put(`/api/web/simInventory/update?simNumber=${esnExist}`, obj)
              .then(() => {
                obj.SimNumberToUpdate = currentvalue;

                toast.success("Inventory Successfully Updated");
              })
              .catch((err) => {
                obj.SimNumberToUpdate = currentvalue;

                toast.error("Inventory Updation Failed");
              });
          }
        } else if (obj.hasOwnProperty("IMEI")) {
          if (formik.values.IMEI.length === 15) {
            api
              .put(`/api/web/simInventory/update?simNumber=${esnExist}`, obj)
              .then(() => {
                obj.SimNumberToUpdate = currentvalue;

                toast.success("Inventory Successfully Updated");
              })
              .catch((err) => {
                obj.SimNumberToUpdate = currentvalue;

                toast.error("Inventory Updation Failed");
              });
          } else {
            setImeiNumberError(true);
          }
        } else {
          api
            .put(`/api/web/simInventory/update?simNumber=${esnExist}`, obj)
            .then(() => {
              obj.SimNumberToUpdate = currentvalue;

              toast.success("Inventory Successfully Updated");
            })
            .catch(() => {
              obj.SimNumberToUpdate = currentvalue;

              toast.error("Inventory Updation Failed");
            });
        }
      }
    }
  }
  return (
    <>
      <div className="singleupload">
        <ToastContainer />
        <div className="flex flex-column">
          <div className="flex" style={{ gap: "1.2rem", height: "6.8rem" }}>
            <div className="calendar_field">
              <p className="field_label">
                ESN/SIM Number To Update (Current){" "}
                <span className="steric">*</span>
              </p>
              <InputText
                placeholder="ESN/SIM Number"
                keyfilter="int"
                value={formik.values.SimNumberToUpdate}
                name="SimNumberToUpdate"
                onChange={(e) => {
                  handlePopulateDataByEsn(e);
                }}
                onBlur={formik.handleBlur}
                className="input_text"
                style={{
                  width: "30rem",
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.SimNumberToUpdate === ""
                      ? "#B9BBCC"
                      : "#9C9EB6",
                }}
              />
              {/* {formik.errors.SimNumberToUpdate && formik.touched.SimNumberToUpdate && (
                            <div className="mt-2" style={{ color: "red" }}>
                                {formik.errors.SimNumberToUpdate}
                            </div>
                        )} */}
            </div>
            <div className="calendar_field">
              <p className="field_label">ESN/SIM Number</p>
              <InputText
                keyfilter="int"
                placeholder="ESN/SIM Number"
                value={formik.values.SimNumber}
                name="SimNumber"
                onChange={(e) => {
                  formik.setFieldValue("SimNumber", e.target.value);
                  setSimNumberError(false);
                }}
                onBlur={formik.handleBlur}
                className="input_text"
                style={{
                  width: "30rem",
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.SimNumber === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
              {simNumberError === true ? (
                <p className=" mt-2 ml-2" style={{ color: "red" }}>
                  Sim Number must be at least 18 and at most 19 characters
                </p>
              ) : undefined}
            </div>
          </div>
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">IMEI</p>
              <InputText
                type="text"
                placeholder="IMEI"
                keyfilter="int"
                value={formik.values.IMEI}
                name="IMEI"
                onChange={(e) => {
                  formik.setFieldValue("IMEI", e.target.value);
                  setImeiNumberError(false);
                }}
                onBlur={formik.handleBlur}
                className="input_text"
                style={{
                  width: "30rem",
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.IMEI === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
              {imeiNumberError === true ? (
                <p className=" mt-2" style={{ color: "red" }}>
                  IMEI Number must be of 15 characters
                </p>
              ) : undefined}
            </div>
            <div className="calendar_field">
              <p className="field_label">Carrier</p>
              <Dropdown
                value={formik.values.carrier}
                options={carrier}
                onChange={(e) => formik.setFieldValue("carrier", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.carrier === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
          </div>
          {/* <div className="calendar_field">
                        <p className="field_label">Department/Vendor Name</p>

                        <Dropdown
                            value={formik.values.agentType}
                            options={department}
                            onChange={(e) => {
                                formik.setFieldValue("agentType", e.value);
                                setDepartmentSelected(e.value);
                            }}
                            placeholder=" Select "
                            className="w-full ml-2"
                        />
                    </div> */}
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">
                Agent Name
                {formik.values.agentType !== "" ? (
                  <Button
                    style={{
                      border: "none",
                      padding: "0rem",
                      backgroundColor: "transparent",
                    }}
                    disabled={!permissions.isCreate}
                  >
                    <i
                      onClick={() => {
                        setAddAgentDialogVisbility((prev) => !prev);
                      }}
                      className="pi pi pi-plus"
                      style={{
                        marginLeft: "0.5rem",
                        fontSize: "1rem",
                        color: "#fff",
                        padding: "0.5rem",
                        cursor: "pointer",
                        paddingLeft: "1rem",
                        borderRadius: "0.5rem",
                        paddingRight: "1rem",
                        background: "#00c0ef",
                      }}
                    ></i>
                  </Button>
                ) : undefined}
              </p>

              <Dropdown
                value={formik.values.AgentName}
                options={agent}
                onChange={(e) => formik.setFieldValue("AgentName", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.AgentName === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
            <div className="calendar_field">
              <p className="field_label">
                Model<span>(MICRO/NANO/SIM)</span>
                {/* <span style={{ color: "red" }}>
                                <i
                                    onClick={() => {
                                        setAddSimModelDialogVisbility((prev) => !prev);
                                    }}
                                    className="pi pi pi-plus"
                                    style={{ marginLeft: "0.5rem", fontSize: "1rem", color: "#fff", padding: "0.5rem", cursor: "pointer", paddingLeft: "1rem", borderRadius: "0.5rem", paddingRight: "1rem", background: "#00c0ef" }}
                                ></i>
                            </span> */}
              </p>
              <Dropdown
                value={formik.values.Model}
                options={Model}
                onChange={(e) => formik.setFieldValue("Model", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.Model === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
          </div>
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">Status</p>
              <Dropdown
                value={formik.values.status}
                options={[
                  { label: "AVAILABLE", value: "available" },
                  { label: "INUSE", value: "inUse" },
                  { label: "DEACTIVATED", value: "deactivated" },
                ]}
                onChange={(e) => formik.setFieldValue("status", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.status === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
            <div className="calendar_field">
              <p className="field_label">Box No</p>
              <InputText
                placeholder="Box Number"
                type="text"
                value={formik.values.box}
                name="box"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="input_text"
                style={{
                  borderColor: formik.values.box === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
          </div>
        </div>
        <div
          className="flex justify-content-end"
          style={{ gap: "1.6rem", marginTop: "5.1rem" }}
        >
          <div className="flex flex-wrap">
            <Button
              className="backbtn"
              label="Back"
              onClick={() => {
                setUpdateInventory(false);
                // setActiveComponent("");
              }}
            />
          </div>
          <Button
            className="nextbtn"
            label="Submit"
            onClick={() => {
              formik.handleSubmit();
              //  handlesubmit()
            }}
            // disabled={!permissions.isCreate}
          />
        </div>
      </div>
      <Dialog
        visible={addsim_Model_dialog_visibility}
        onHide={() => {
          setAddSimModelDialogVisbility((prev) => !prev);
        }}
      >
        <AddSimModelDialog agent={"Dummy"} />
      </Dialog>
      <Dialog
        visible={add_agent_detail_dialog_visibility}
        onHide={() => {
          setAddAgentDialogVisbility((prev) => !prev);
        }}
      >
        <AddAgentDetail agent={"Dummy"} />
      </Dialog>
      <Toast ref={ref} />
    </>
  );
}
